import { type PushToFIProviderState, type StateTree } from '@makemydeal/dr-dash-types';
import { pushToFIProviderInitialState } from '../reducers/pushToFIReducer';

export { pushToFIProviderInitialState };

export const getPushToFIStatus = (state: StateTree, providerId: string): PushToFIProviderState | undefined => {
    return state.pushToFI?.[providerId];
};
